<template>
  <v-content app>
    <v-container fluid>
      <v-layout>
        <v-flex sm12>
          <v-breadcrumbs class="pb-1" icons divider=">">
            <v-breadcrumbs-item>
              <div class="text-uppercase">HOME</div>
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
      <v-card class="v-card---style">
        <section>
          <h2 class="mb-4">
            Your Workspace
          </h2>
          <div class="mt-4" v-for="workspace in workspaces">
            <v-card>
              <div class="wrap-workspace">
                <h2 class="mb-4 workspace-title">{{ workspace.name }}</h2>
                <template v-if="current_user.is_admin === true || current_user.is_staff === true">
                  <router-link :to="workspace.management_path">
                    <v-btn class="mr-3">
                      <span class="hidden-xs-only mr-2 text-capitalize">Manage Workspace</span>
                      <v-icon color="primary" size="18" class="workspace-settings">settings</v-icon>
                    </v-btn>
                  </router-link>
                </template>
              </div>
              <carousel :navigationEnabled="true" :paginationEnabled="false" :perPage="4">
                <slide v-for="app in workspace.apps" :key="app.id">
                  <router-link :to="app.path">
                    <div v-if="workspace.id === app.workspace" class="app-wrap">
                      {{ app.name }}
                    </div>
                  </router-link>
                </slide>
              </carousel>
            </v-card>

          </div>
        </section>
      </v-card>
    </v-container>
  </v-content>
</template>

<style>
  .v-card---style {
    padding: 15px 30px 30px 30px;
  }

  .wrap-workspace {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .VueCarousel {
    padding: 5px 10px 25px 10px;
  }

  .v-toolbar__content > :first-child.v-btn--icon, .v-toolbar__extension > :first-child.v-btn--icon {
    margin-left: 15px !important;
  }

  .v-breadcrumbs__item {
    color: gray;
    font-size: 12px;
  }

  .container {
    padding: 15px 24px 24px 24px !important;
  }

  .v-breadcrumbs {
    padding: 0 !important;
    margin-bottom: 10px !important;
  }

  .workspace-settings {
    font-size: 18px;
  }

  .toast-top-right {
    top: 70px !important;
    right: 23px !important;
  }

  .workspace-title {
    margin-top: 20px;
    margin-left: 25px;
    font-weight: 500;
    text-transform: uppercase;
    color: #333;
    font-size: 19px;
    margin-bottom: 15px !important;
  }

  @media screen and (max-width: 992px) {
    .logo-position {
      position: relative;
      left: 10px;
    }

    .small-logo {
      max-width: 60px;
    }
  }

  button.VueCarousel-dot.VueCarousel-dot--active {
    background-color: #0033a0 !important;
  }

  button.VueCarousel-navigation-button.VueCarousel-navigation-prev {
    color: #0033a0 !important;
    top: 50%;
  }

  button.VueCarousel-navigation-button.VueCarousel-navigation-next {
    color: #0033a0 !important;
    top: 50%;
  }

  .analytic-number--style {
    font-size: 40px;
    font-weight: bold;
  }

  .app-wrap {
    color: #0033a0 !important;
    text-align: center;
    background: #eaecff;
    padding: 40px;
    border: 1px solid #eaecff;
    margin: 0 20px 0 15px;
    width: 80%;
    font-weight: 500;
    font-size: 19px;
    border-radius: 10px;
  }

  .primary--text {
    color: #0033a0 !important;
  }

  .toast-top-right {
    top: 70px;
    right: 23px;
  }
</style>

<script>
  import {axiosInstance} from '../axios-auth'
  import {Carousel, Slide} from 'vue-carousel';

  export default {
    components: {
      Carousel,
      Slide
    },
    data() {
      return {
        current_user: "",
        workspaces: []
      }
    },
    methods: {
      getCurrentUser() {
        const self = this;
        let url = 'me/'
        axiosInstance.get(url).then(function (response) {
          self.current_user = response.data;
        }).catch(function (error) {
          console.log(error)
        })
      },
      getWorkspaces() {
        let self = this;

        axiosInstance.get('workspaces/')
          .then(response => {
            self.workspaces = response.data;

            for (let i = 0; i < self.workspaces.length; i++) {
              self.workspaces[i].management_path = "/" + self.workspaces[i].name + "/" + self.workspaces[i].id + "/workspace_management/";
              for (let k = 0; k < self.workspaces[i].apps.length; k++) {
                for (let key in self.workspaces[i].apps[k]) {
                  self.workspaces[i].apps[k].path = "/" + self.workspaces[i].name + "/" + self.workspaces[i].id + "/" + self.workspaces[i].apps[k].name + "/" + self.workspaces[i].apps[k].id + "/"
                }
              }
            }
          })
          .catch(e => {
            console.log("e", e)
            // if (e.response.data.status === 500 || e.response.data.status === 502 || e.response.data.status === 404) {
            //   self.$router.push({
            //     name: 'login', path: '/login'
            //   })
            // }
            // self.errors.push(e)
          })
      }
    },
    beforeMount() {
      this.getCurrentUser()
      this.getWorkspaces()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Home.vue